@let isBoxInputType = formElementType === 'checkbox' || formElementType === 'radio';

<div
  [attr.data-testid]="`field-${safeId()}`"
  class="input"
  [attr.data-type]="formElementType"
  [attr.data-layout]="isBoxInputType ? 'box' : 'field'">
  @let inputTestId = `field-input-${safeId()}`;

  @if (formElementType === 'checkbox' && type() === 'switch') {
    <div class="switch-container">
      @let isChecked = optionsGroup?.isSelected(value()) ?? localValue() === true;
      <label class="switch__content">
        <input
          #input
          type="checkbox"
          class="switch__input"
          [class.switch__input--disabled]="disabled()"
          [attr.id]="safeId()"
          [attr.name]="name()"
          [checked]="isChecked"
          [value]="value() ?? localValue()"
          [disabled]="disabled()"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          (change)="onInputChanged(!isChecked, $event)" />
        <span class="switch__slider"></span>
      </label>
      <label
        [for]="safeId()"
        class="switch__label">
        {{ label() }}
        <ng-content />
      </label>
    </div>
  } @else {
    <label
      [for]="safeId()"
      class="label">
      @if (formElementType === 'radio') {
        @let isChecked = optionsGroup?.isSelected(value()) ?? localValue() === value();
        <input
          #input
          type="radio"
          class="control"
          [attr.data-size]="size()"
          [attr.data-error]="hasErrors()"
          [attr.id]="safeId()"
          [attr.data-testid]="inputTestId"
          [disabled]="disabled()"
          [attr.name]="name()"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          [checked]="isChecked"
          [value]="value() ?? localValue()"
          (change)="onInputChanged(value(), $event)" />
        <span class="mark mark__dot"></span>
      } @else if (formElementType === 'checkbox') {
        @let isChecked = checked() ?? optionsGroup?.isSelected(value()) ?? localValue() === true;
        <input
          #input
          type="checkbox"
          class="control"
          [attr.data-size]="size()"
          [attr.data-error]="hasErrors()"
          [attr.id]="safeId()"
          [attr.data-testid]="inputTestId"
          [disabled]="disabled()"
          [attr.name]="name()"
          [attr.data-indeterminate]="indeterminate()"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          [checked]="isChecked"
          [value]="value() ?? localValue()"
          (change)="onInputChanged(!isChecked, $event)" />
        <span class="mark mark__check"></span>
      }
      {{ label() }}
      <ng-content />
    </label>
  }

  @if (formElementType === 'textarea') {
    <textarea
      #input
      class="control"
      [attr.data-size]="size()"
      [attr.data-error]="hasErrors()"
      [id]="id || name()"
      [attr.data-testid]="inputTestId"
      [readOnly]="readOnly()"
      [disabled]="disabled()"
      [attr.name]="name()"
      [rows]="rows()"
      [attr.placeholder]="placeholder() ?? null"
      [(ngModel)]="localValue"
      (ngModelChange)="onInputChanged($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)">
        localValue
    </textarea>
  } @else if (!isBoxInputType) {
    <div
      class="wrapper"
      [attr.data-error]="hasErrors()"
      [attr.data-disabled]="disabled()"
      #inputGroupDiv>
      <div class="left">
        <ng-content select="[left]" />
      </div>
      <input
        #input
        class="control"
        [autocomplete]="autocomplete()"
        [attr.data-size]="size()"
        [attr.id]="safeId()"
        [attr.data-testid]="inputTestId"
        [type]="type()"
        [readOnly]="readOnly()"
        [disabled]="disabled()"
        [maxlength]="maxLength()"
        [attr.name]="name()"
        [attr.placeholder]="placeholder() ?? null"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        [(ngModel)]="localValue"
        (ngModelChange)="onInputChanged($event)" />
      <div class="right">
        @if (showClearButton()) {
          <evc-button
            class="clear-button"
            nativeType="button"
            label="Clear"
            icon="close"
            frame="none"
            (click)="onClear()" />
        }
        <ng-content select="[right]" />
      </div>
    </div>
  }

  @if (hasErrors() || (showError() && errorText() !== '')) {
    <div class="errors">
      @if (errorText() !== '') {
        <evc-icon
          class="errors-icon"
          icon="alert-fill"
          size="xs" />
        <p class="errors-text">{{ errorText() }}</p>
      } @else {
        @for (error of controlDir?.errors | keyvalue; track error.key) {
          <evc-icon
            class="errors-icon"
            icon="alert-fill"
            size="xs" />
          <p class="errors-text">{{ error.value.message }}</p>
        }
      }
    </div>
  }
</div>
